<template>
  <div v-if="cardActivationEnhancementsFooterEnabled" class="footer-section">
    <ClientOnly>
      <CreditcardBannerConsumableCreditCardBanner
        source="footer"
        :card-activation-enhancements-enabled="cardActivationEnhancementsEnabled"
        card-activation-enhancements-footer-enabled
        bringback-page="CreditGateway"
        credit-acquisition="footer"
      />
    </ClientOnly>
  </div>
  <section v-else-if="creditCardData" class="social-card" @click="popupLinkHandler">
    <!-- eslint-disable vue/no-v-html -->
    <div class="white margin-bottom-xs" v-html="offerHeading"></div>
    <!-- eslint-enable -->

    <div class="footer-card-content">
      <div class="cell credit-card-img margin-right-xs">
        <Picture image-url="https://assets.macysassets.com/dyn_img/site_ads/cc_1455724_1457104.png" alt="" :using-scene7="false" />
      </div>
      <div class="white small">
        <!-- eslint-disable vue/no-v-html -->
        <div class="margin-bottom-xxs" v-html="offerContent"></div>
        <!-- eslint-enable -->
        <div>
          <CommonLink
            v-for="action in offerActions"
            :key="action.value"
            :href="action.value"
            class="credit-card-link"
            @click="fireAnalytics(action.text)"
          >
            {{ action.text }}
          </CommonLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, defineAsyncComponent } from 'vue';

import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';

import { fireLinkTag } from '#shared/features/analytics/tagManager';
import { usePopupLink } from '~/composables/features/usePopupLink';
import { GET_CREDIT_CARD_DATA } from '#shared/types/getters';
import useKillswitches from '~/composables/useKillswitches';
import CreditCardBannerSkeleton from './CreditCardBannerSkeleton.vue';

const CreditcardBannerConsumableCreditCardBanner = defineAsyncComponent({
  loader: () => import('@nuxt-common/creditcard-banner-consumable/app/components/CreditCardBanner.vue'),
  loadingComponent: CreditCardBannerSkeleton,
});

const { popupLinkHandler } = usePopupLink();

const navFooter = useNavFooter();
const killswitches = useKillswitches();
const creditCardData = computed(() => navFooter?.[GET_CREDIT_CARD_DATA]);

const getFromCreditCardData = (key) => computed(() => creditCardData.value?.[key]);
const cardActivationEnhancementsEnabled = computed(() => killswitches?.value?.cardActivationEnhancementsEnabled);
const cardActivationEnhancementsFooterEnabled = computed(() => killswitches?.value?.cardActivationEnhancementsFooterEnabled);
const offerHeading = getFromCreditCardData('heading');
const offerContent = getFromCreditCardData('content');
const offerActions = getFromCreditCardData('actions');

function fireAnalytics(actionText) {
  if (actionText === 'Apply Now') {
    const payload = {
      event_name: 'cc apply now',
      link_name: 'cc apply now footer',
    };
    fireLinkTag(payload);
  }
}
</script>

<style lang="scss" brand="mcom" scoped>
@import '~/assets/scss/mixins.mcom.scss';

.credit-card-img {
  width: 57px;
}

.credit-card-link:not(:first-child) {
  @include margin-left-xxs;

  @include breakpoint(large up) {
    @include margin-left-xs;
  }
}

.apply-now {
  display: block;
}

.footnote {
  color: $white;
  text-decoration: none;
}

.footnote-2 {
  @include breakpoint(large up) {
    display: inline-block;
    margin-right: 2px;
  }
}
</style>

<style lang="scss" brand="mcom">
.footer-card-content {
  display: flex;
  flex-flow: row nowrap;

  a {
    color: $white;
  }
}
</style>
